<div class="credit-info-container flex flex-column gap-3 mb-5">
  <div>
    <div>
      <span class="title">
        Credit Verification
      </span>
    </div>
    <div class="sub-title mt-1">
      Please answers the questions below.
    </div>
    <p-divider></p-divider>
  </div>
  <div>
    <sp-form-wrapper [formGroup]="questionnaireForm">
      <div class="grid">
        <div class="col-12">
          @for (question of questionData; track question; let i = $index) {
            <div class="field">
              <!-- Question Label -->
              <label class="form-label required" for="question{{i}}">{{ question.QuestionText }}</label>
              <div>
                <p-select styleClass="w-full pt-1" [options]="question.CreditAnswers.CreditAnswer"
                  optionLabel="AnswerText" optionValue="AnswerId" placeholder="Please select one"
                  (onChange)="updateFormControl($event, i)" class="drop-down-selected">
                </p-select>
                @if (requiredFieldValidation(i)) {
                  <sp-control-error>
                    <span class="text-red-500 font-bold">
                      Please complete this field.
                    </span>
                  </sp-control-error>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </sp-form-wrapper>


  </div>
  <div>
    @if (questionnaireForm?.invalid && isSubmitted) {
      <div>
        <sp-control-error >
          <span class="text-red-500 mb-1 font-bold">
            Missing field(s). Please complete all required fields.
          </span>
        </sp-control-error>
      </div>
    }
    <div class="mb-3">
      <p-button label="SUBMIT" styleClass="p-button-lg w-full p-button-primary p-button-radius" (onClick)="onFormSubmit()" />
    </div>
    <div class="mb-3">
      <p-button label="CANCEL" [link]="true" styleClass="w-full" (onClick)="onFormCancel()" />
    </div>
  </div>
  <div class="sub-title">
    Private information entered via this secure form will not be visible by the sales agent.
  </div>
</div>

<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancelConfimation($event)"></app-confirm-popup>